import '@hotwired/turbo'
// Self-hosted fonts, so the site looks the same on every device: Inter for
// body text (--sans), JetBrains Mono for labels and the menu (--mono); Didot
// is bundled in app.css. Each subset carries a unicode-range, so the browser
// downloads latin always and latin-ext (Czech letters) only on pages that use
// them; the other subsets never load here.
import '@fontsource/inter/400.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '../css/app.css'
import '../css/footer.css'
import '../css/login.css'
import '../css/menu.css'
import { createApp } from 'vue'
import { revealBody } from './islands.js'
import { installEntranceExit } from './entrance.js'
import { installMenu } from './menu.js'

const islands = {
  editorial: () => import('./islands/Editorial.vue').then((m) => m.default),
}

function mount(Component, props, el) {
  return createApp(Component, props).mount(el)
}

installEntranceExit()
installMenu()

// Reveal the page once every island is mounted so the user never sees an
// unstyled / pre-Vue flash. The inline v-cloak rule in <head> keeps the body
// hidden until then. turbo:render covers form re-renders, which never fire
// turbo:load.
for (const event of ['turbo:render', 'turbo:load']) {
  document.addEventListener(event, () => revealBody(document.body, islands, mount))
}
